import httpClient from './httpClient'

const apiGetDepts = val => httpClient.post('/inc/contactsv2.php', val),
    apiGenNumberRep = val => httpClient.post('/inc/reports-numberv2.php', val),
    apiGenReport = val => httpClient.post('/inc/rest/Report/' + val.repName, val),
    apiGenProd = val => httpClient.post('/inc/utilv2.php', val),
    apiModNote = val => httpClient.post('/inc/utilv2.php', val)

export { apiGetDepts, apiGenNumberRep, apiGenReport, apiGenProd, apiModNote }
